import { render, staticRenderFns } from "./CompanyFileSizeLimit.vue?vue&type=template&id=36b63488&"
import script from "./CompanyFileSizeLimit.vue?vue&type=script&lang=ts&"
export * from "./CompanyFileSizeLimit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports